import { SaveButtonHook } from './SaveButton.hook'
import { ButtonSuccessStyle } from '../styles'
import SaveConfirmationModal from '../SaveConfirmationModal'
import RequiredModal from '../RequiredModal/RequiredModal'

const SaveButton = () => {
  const {
    processClaimForm,
    isLoading,
    isModalOpen,
    requiredModalType,
    handleModalConfirm,
    handleModalClose,
    handleRequiredModalClose,
    isSaveDisabled,
  } = SaveButtonHook()

  return (
    <>
      <ButtonSuccessStyle
        onClick={processClaimForm}
        loading={isLoading}
        disabled={isLoading || isSaveDisabled}
      >
        บันทึก
      </ButtonSuccessStyle>
      <SaveConfirmationModal
        isModalOpen={isModalOpen}
        onClose={handleModalClose}
        onConfirm={handleModalConfirm}
        isLoading={isLoading}
      />
      <RequiredModal
        isModalOpen={!!requiredModalType}
        onClose={handleRequiredModalClose}
        requiredType={requiredModalType}
      />
    </>
  )
}

export default SaveButton
